import Vue from 'vue'
import Router from 'vue-router'
import * as AppStorage from '../storage/appstorage';
import client from '../backend/client'
import Config from '../assets/config';
import DiagnostFinance2 from "../views/DiagnostFinance2";
import Group from "../views/Group";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Company = () => import('@/views/Company')
const Diagnost = () => import('@/views/Diagnost')
const DiagnostFactors = () => import('@/views/DiagnostFactors')
const DiagnostForm = () => import('@/views/DiagnostForm')
const DiagnostFinance = () => import('@/views/DiagnostFinance')
const DiagnostFormVerify = () => import('@/views/DiagnostFormVerify')
const DiagnostInterview = () => import('@/views/DiagnostInterview')
const DiagnostFinanceDetail = () => import('@/views/DiagnostFinanceDetail')
const DiagnostFinal = () => import('@/views/DiagnostFinal')
const Widgets = () => import('@/views/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const Flags = () => import('@/views/icons/Flags')
const FontAwesome = () => import('@/views/icons/FontAwesome')
const SimpleLineIcons = () => import('@/views/icons/SimpleLineIcons')
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')
const Report = () => import('@/views/full-reports/VerifyList')
const ReportComplex = () => import('@/views/full-reports/ComplexList')
const Region = () => import('@/views/full-reports/Region')
const ReportComplexManager = () => import('@/views/full-reports/ComplexManager')
const Manager = () => import('@/views/full-reports/Manager')
const Charts = () => import('@/views/Charts')

Vue.use(Router)

let router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Главная',
      component: DefaultContainer,
      children: [
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'dashboard',
          name: 'В процессе верификации',
          component: Dashboard
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'company/:id',
          name: 'Карточка компании',
          component: Company
        },
        {
          path: '/groups',
          name: 'Потоки обучения',
          component: Group
        },
          {
              path: 'diagnost/:id',
              name: 'Комплексная диагностика',
              component: Diagnost
          },
          {
            path: 'diagnost/:id/form',
            name: 'Анкета экспортной зрелости',
            component: DiagnostForm
          },
          {
              path: 'diagnost/:id/factors',
              name: 'Процедура проведения аудита компании на предмет наличия/отсутствия стоп-факторов для осуществления экспорта',
              component: DiagnostFactors
          },
          {
              path: 'diagnost/:id/finance',
              name: 'Экспресс-диагностика финансового положения компании',
              component: DiagnostFinance2
          },
          {
              path: 'diagnost/:id/verify',
              name: 'Верификация анкеты экспортной зрелости',
              component: DiagnostFormVerify
          },
        {
          path: 'diagnost/:id/interview',
          name: 'Структурированное интервью с представителями компании',
          component: DiagnostInterview
        },
        {
          path: 'diagnost/:id/finance-detail',
          name: 'Оценка финансового состояния',
          component: DiagnostFinanceDetail
        },
        {
          path: 'diagnost/:id/final',
          name: 'Итоговый сводный отчет комплексной диагностики компании',
          component: DiagnostFinal
        },
        {
            path: '/reports',
            meta: { label: 'Отчеты о верификации'},
            component: {
              render (c) { return c('router-view') }
            },
            children: [
              {
                path: '',
                component: Report
              },
              {
                path: ':region/manager/:user',
                name: 'Отчет по менеджеру',
                component: Manager
              },
            ]
        },
        {
          path: '/complex-reports',
          meta: { label: 'Отчеты о статусе комплексной диагностики'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: ReportComplex
            },
            {
              path: 'region/:region',
              name: 'Сводный отчет о статусе комплексной диагностики компаний в регионе (с учетом этапов комплексной диагностики)',
              component: Region
            },
            {
              path: ':region/manager/:user',
              name: 'Отчет по менеджеру о статусе комплексной диагностики компаний',
              component: ReportComplexManager
            },
          ]
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users,
            },
            {
              path: ':id',
              meta: { label: 'User Details'},
              name: 'User',
              component: User,
            },
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'CoreUI Icons',
              component: CoreUIIcons
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            },
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/',
      redirect: '/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login,
          meta: {
              guest: true
          }
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
});

client.interceptors.response.use((response) => {
    return response;
}, (error) => {
    if(error.response.data.code === 401 && router.currentRoute.name !== 'Login') {

        client
            .get("/oauth/v2/token", {
                client_id:     Config.API.clientId,
                grant_type:    'refresh_token',
                refresh_token: AppStorage.get('token')
            })
            .then(res => {
                if(res.status === 200) {
                    // store the data in localStorage
                    AppStorage.set("token", res.data.token);
                    AppStorage.set("refresh", res.data.refresh_token);
                    router.push('/');
                } else {
                    router.push('/login');
                }

            })
            .catch(res => {
                console.error(res);
            });
    }
    return Promise.reject(error)
});

router.beforeEach((to, from, next) => {
    console.log(to)
    if(to.matched.some(record => record.meta.guest)) {
        return next()
    } else if (AppStorage.get('token') == null) {
        return next({
            path: '/login',
            params: { nextUrl: to.fullPath }
        })
    }
    return next();
})

export default router;
